import { Tag } from "lucide-react";

const NONE = "__none__";

export const offerKey = (b) => b.offer || NONE;

export const countOffers = (bookings) => {
  const counts = new Map();
  bookings.forEach((b) => counts.set(offerKey(b), (counts.get(offerKey(b)) || 0) + 1));
  return [...counts.entries()]
    .map(([key, count]) => ({ key, label: key === NONE ? "Sans offre" : key, count }))
    .sort((a, b) => (a.key === NONE) - (b.key === NONE) || b.count - a.count);
};

const Chip = ({ active, onClick, testId, children }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-xs font-semibold transition-colors duration-200 ${
      active ? "border-argia-red bg-argia-red text-white" : "border-[#2C2A29]/15 bg-white text-argia-ink hover:border-argia-red/50"
    }`}
  >
    {children}
  </button>
);

const Count = ({ active, n }) => (
  <span className={`rounded-full px-1.5 text-[11px] ${active ? "bg-white/20" : "bg-argia-stone text-argia-muted"}`}>{n}</span>
);

export const OfferFilter = ({ bookings, selected, onChange }) => {
  const stats = countOffers(bookings);
  if (stats.length <= 1 && stats[0]?.key === NONE) return null;
  return (
    <div className="mt-10 rounded-2xl bg-argia-stone p-6" data-testid="offer-filter">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-argia-muted">
        <Tag size={14} strokeWidth={1.5} className="text-argia-red" /> Réservations par offre
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <Chip active={!selected} onClick={() => onChange(null)} testId="offer-chip-all">
          Toutes <Count active={!selected} n={bookings.length} />
        </Chip>
        {stats.map((s) => (
          <Chip
            key={s.key}
            active={selected === s.key}
            onClick={() => onChange(selected === s.key ? null : s.key)}
            testId={`offer-chip-${s.key === NONE ? "none" : s.key.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            {s.label} <Count active={selected === s.key} n={s.count} />
          </Chip>
        ))}
      </div>
    </div>
  );
};
